export function isTrialEligible(user, billingStatus) {
    return !(user?.usedFreeTrial || billingStatus?.usedFreeTrial);
}

export function getPlanSelectionIntro(trialEligible) {
    if (trialEligible) {
        return {
            title: 'Select A Plan To Start Your 7-Day Free Trial',
            subtitle: 'Cancel anytime. You will only be billed at the end of the free trial.',
        };
    }
    return {
        title: 'Select A Plan To Continue',
        subtitle: 'You will be billed for the plan you select. Cancel anytime.',
    };
}

export function getSubscriptionGateBannerMessage(trialEligible) {
    return trialEligible
        ? 'Select a plan to start your free trial.'
        : 'Select a plan to continue using AttorneyAide.';
}
